module.exports = __webpack_public_path__ + "static/media/AMXExpanded.d0a02799.svg";